import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plan-starter",
  "use": "plan-starter-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"plan-starter\"><path fill=\"#6B7A8B\" fill-rule=\"evenodd\" d=\"M10 .752 9.542 1.8A15.05 15.05 0 0 1 1.8 9.542L.752 10l1.048.458A15.05 15.05 0 0 1 9.542 18.2L10 19.248l.458-1.048a15.05 15.05 0 0 1 7.742-7.742L19.248 10 18.2 9.542A15.05 15.05 0 0 1 10.458 1.8zM16.84 10A16.06 16.06 0 0 0 10 16.84 16.06 16.06 0 0 0 3.16 10 16.06 16.06 0 0 0 10 3.16 16.06 16.06 0 0 0 16.84 10\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol